import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";
import { fileUrl, initials } from "@/lib/fileUrl";
import { Hash, Building2 } from "lucide-react";

const timeAgo = (iso) => {
  if (!iso) return "";
  const s = (Date.now() - new Date(iso).getTime()) / 1000;
  if (s < 60) return "now";
  if (s < 3600) return `${Math.floor(s / 60)}m`;
  if (s < 86400) return `${Math.floor(s / 3600)}h`;
  return `${Math.floor(s / 86400)}d`;
};

const ConvAvatar = ({ c }) => {
  if (c.type === "channel") return <div className="flex h-10 w-10 items-center justify-center rounded-full bg-primary/15 text-primary"><Hash className="h-5 w-5" /></div>;
  if (c.type === "partner") return c.avatar
    ? <img src={fileUrl(c.avatar)} alt="" className="h-10 w-10 rounded-full object-contain bg-muted" />
    : <div className="flex h-10 w-10 items-center justify-center rounded-full bg-amber-500/15 text-amber-500"><Building2 className="h-5 w-5" /></div>;
  return (
    <Avatar className="h-10 w-10">
      {c.avatar && <AvatarImage src={fileUrl(c.avatar)} alt="" />}
      <AvatarFallback className="bg-primary/15 text-primary text-xs">{initials(c.title)}</AvatarFallback>
    </Avatar>
  );
};

export const ConversationList = ({ conversations, activeId, onSelect }) => {
  if (!conversations.length) {
    return <p className="p-6 text-center text-sm text-muted-foreground" data-testid="conversations-empty">No conversations yet. Start one with the + button.</p>;
  }
  return (
    <div className="divide-y divide-border/60" data-testid="conversation-list">
      {conversations.map((c) => (
        <button key={c.conversation_id} onClick={() => onSelect(c.conversation_id)}
          data-testid={`conversation-item-${c.conversation_id}`}
          className={`flex w-full items-center gap-3 px-3 py-3 text-left transition-colors hover:bg-accent/50 ${activeId === c.conversation_id ? "bg-accent/60" : ""}`}>
          <ConvAvatar c={c} />
          <div className="min-w-0 flex-1">
            <div className="flex items-center justify-between gap-2">
              <p className="truncate text-sm font-medium text-foreground">{c.title}</p>
              <span className="shrink-0 text-[10px] text-muted-foreground">{timeAgo(c.last_message_at)}</span>
            </div>
            <p className="truncate text-xs text-muted-foreground">{c.last_text || c.subtitle}</p>
          </div>
          {c.unread > 0 && (
            <span data-testid={`conversation-unread-${c.conversation_id}`}
              className="flex h-5 min-w-5 items-center justify-center rounded-full bg-primary px-1.5 text-[10px] font-bold text-primary-foreground">{c.unread}</span>
          )}
        </button>
      ))}
    </div>
  );
};
